import React from 'react';
import {
  getTradeInAllowance,
  getTradeInPayoff,
} from '@upstart/harmony/lib/dealer-utils';
import { FinanceResponseData } from '@upstart/harmony/lib/legos/financingTypes';
import { RicMetadata, TradeInItemType } from '../ricFormTypes';
import { calculateSumValue, formatCurrency } from '../ricFormUtils';
import TradeInItem from '../Components/TradeInItem';
import { SectionItem } from '../Components';

const PRICE_VALUE_FIELDS = ['tradeInAllowance', 'payOff', 'netTrade'];

const SchemaTradeInInput = ({
  formElement,
  responseData,
  fetchResponseWithUpdatedData,
  ricMetadata,
}: {
  formElement: TradeInItemType;
  responseData: FinanceResponseData;
  fetchResponseWithUpdatedData: (data: Partial<FinanceResponseData>) => void;
  ricMetadata?: RicMetadata;
}) => {
  const { title, subtitle, tradeInField, value, sumValue, required } =
    formElement;
  const { numTradeIns = 1 } = ricMetadata ?? {};

  const tradeIns = responseData?.tradeIns ?? [];
  const tradeInAllowance = getTradeInAllowance(tradeIns);
  const tradePayoff = getTradeInPayoff(tradeIns);
  const netTrade = tradeInAllowance - tradePayoff;

  // Display value totals for relevant fields
  let displayValue = sumValue
    ? formatCurrency(calculateSumValue(responseData, sumValue))
    : (value ?? '');
  if (!displayValue && PRICE_VALUE_FIELDS.includes(tradeInField)) {
    switch (tradeInField) {
      case 'tradeInAllowance':
        displayValue = formatCurrency(tradeInAllowance);
        break;
      case 'payOff':
        displayValue = formatCurrency(tradePayoff);
        break;
      case 'netTrade':
        displayValue = formatCurrency(netTrade);
        break;
    }
  }

  return (
    <>
      <SectionItem title={title} value={displayValue} subtitle={subtitle} />
      <div className="form-subsection">
        <TradeInItem
          type={tradeInField}
          responseData={responseData}
          fetchResponseWithUpdatedData={fetchResponseWithUpdatedData}
          maxTradeIns={numTradeIns}
          required={required}
        />
      </div>
    </>
  );
};

export default SchemaTradeInInput;
